import {
    SET_TECHNOLOGIES,
    ADD_TECHNOLOGIE,
    UPDATE_TECHNOLOGIE,
    DELETE_TECHNOLOGIE,
    SET_LOADING,
    SET_ERROR,
    SET_FORM_DATA,
    RESET_FORM
} from './actions';

const initialState = {
    technologies: [],
    loading: false,
    error: null,
    formData: {
        name: '',
        image: '',
        _id: null
    }
};

const technologieReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return { ...state, loading: action.payload };
        case SET_ERROR:
            return { ...state, error: action.payload };
        case SET_TECHNOLOGIES:
            return { ...state, technologies: action.payload };
        case ADD_TECHNOLOGIE:
            return { ...state, technologies: [...state.technologies, action.payload] };
        case UPDATE_TECHNOLOGIE:
            return {
                ...state,
                technologies: state.technologies.map((tech) =>
                    tech._id === action.payload._id ? action.payload : tech
                )
            };
        case DELETE_TECHNOLOGIE:
            return {
                ...state,
                technologies: state.technologies.filter((tech) => tech._id !== action.payload)
            };
        case SET_FORM_DATA:
            return { ...state, formData: action.payload };
        case RESET_FORM:
            return {
                ...state,
                formData: { name: '', image: '', _id: null }
            };
        default:
            return state;
    }
};

export default technologieReducer;
